import {
  SET_FEEDBACK,
  CLEAR_FEEDBACKS,
} from '../constants/actionTypes';

export const setFeedbackAction = message => ({
  type: SET_FEEDBACK,
  payload: message,
});

export const clearFeedbacksAction = () => ({
  type: CLEAR_FEEDBACKS,
})



// WEBPACK FOOTER //
// ./src/actions/feedback.js